import { render, staticRenderFns } from "./TechnologyPartner.vue?vue&type=template&id=1419453e"
import script from "./TechnologyPartner.vue?vue&type=script&lang=js"
export * from "./TechnologyPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports